export const DATAENTITY = 'dataentity';
